import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {selectChapterRead} from '../../../store/reducers';
import {useBreakpoint} from '../../../styles';

const ComicProgressBar = ({comic, size}) => {
    const progress = useSelector(state =>
        comic.chapters.map(chapter => selectChapterRead(state, chapter.id)),
    );

    const breakpoint = useBreakpoint();

    return (
        <Container>
            {comic.chapters.map((chapter, index) => {
                return (
                    <ChapterProgressItem
                        key={index}
                        isFirst={index === 0}
                        isLast={index === comic.chapters.length - 1}
                        selected={progress[index]}
                        size={breakpoint}
                    />
                );
            })}
        </Container>
    );
};

const makeMask = (maskStart, maskEnd, horizontal, width, height) => {
    if (horizontal) {
        return `${maskStart ? 1 : 0}px 0px, ${width}px 0px, ${
            maskEnd ? width - 1 : width
        }px ${height}px, 0px ${height}px`;
    } else {
        return `0px ${maskStart ? 1 : 0}px, ${width}px 0px, ${width}px ${
            maskEnd ? height - 1 : height
        }px, 0px ${height}px`;
    }
};

const Container = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

export default ComicProgressBar;

const ChapterProgressItem = ({isFirst, isLast, selected, breakpoint}) => {
    let size;
    if (['xs', 'sm', 'mobile'].includes(breakpoint)) {
        size = 'small';
    } else if (['md'].includes(breakpoint)) {
        size = 'large';
    } else {
        size = 'medium';
    }

    const width = size === 'large' ? 14 : size === 'medium' ? 10 : 8;
    const height = size === 'large' ? 10 : size === 'medium' ? 8 : 6;

    return (
        <ItemContainer
            style={{width, height}}
            points={makeMask(!isFirst, !isLast, true, width, height)}
            selected={selected}
        />
    );
};

const ItemContainer = styled.div`
    background: ${props =>
        props.selected
            ? `linear-gradient(90deg, #f55a61 0%, #ec098c 100%)`
            : `#494249;`};
    clip-path: ${props => `polygon(${props.points})`};
    margin-bottom: 1px;
`;
